import type { FaireProductEntity } from "../../entity_types/product";

export const p_sgfpxqsg5x: FaireProductEntity = {
  token: "p_sgfpxqsg5x",
  type: "product",
  name: "Cece Body Mist | Half Case",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/36aac5c968db80389df2e741a8d3ba026afd4efc771ee14ff944a45d52a1572b.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/477f428fd79a28703eb3a3d57ae363d416339966d8045586c608ca48f3b86649.webp",
    "https://cdn.faire.com/fastly/ddef241a913554eeb3f302ef58fc00f26a7758a81a101a53b57a9de02db27f77.webp",
  ],
  priceDollars: 21.66,
  description:
    "Cece Fine Fragrance Body Mist\n\nExperience Cece, our founder’s signature and most iconic fragrance, now in a delicate fine fragrance mist. This luxury body mist envelops skin in a buildable layer of scent—perfect for a refreshing pick-me-up. Wear it light for everyday freshness or reapply throughout the day for a long-lasting perfume experience.\n\n𝐓𝐡𝐞 𝐂𝐞𝐜𝐞 𝐒𝐜𝐞𝐧𝐭\nGrounded, mysterious, and addictive—cedarwood smoke, sweet cardamom, cinnamon, and white leather come together in a sophisticated, fine fragrance that lingers beautifully.\n\n𝐅𝐫𝐚𝐠𝐫𝐚𝐧𝐜𝐞 𝐍𝐨𝐭𝐞𝐬\n• Guatemalan cardamom*\n• Dried mate absolute leaves*\n• Sri Lankan cinnamon*\n• Carrot seeds and leaves\n• Indonesian patchouli oil*\n• Vetiver oil*\n\n*Eco-friendly and sustainably sourced ingredients\n\n𝐇𝐨𝐰 𝐭𝐨 𝐔𝐬𝐞\nSpray lightly onto skin from 6–8 inches away. Reapply as needed for all-day wear.\n\nSize: 3.4 fl oz / 100 ml",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:18.623Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
